import { RootState } from "../store";
import { useAppSelector } from "../store/hooks";
import { PermissionGroups } from "../interfaces/User";

export default function useIsUserRcAdmin(): boolean {
  const userGroups = useAppSelector(
    (state: RootState) => state.userContext.userCreds.userGroups || []
  );

  return userGroups.includes(PermissionGroups.ResourceCentreAdmin);
}
